import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BudgetplanFormComponent } from './budgetplan-form.component';

const routes: Routes = [{ path: '', component: BudgetplanFormComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BudgetplanFormRoutingModule { }
